import { useContext } from "react";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import { ExternalLinkButton } from "@sharedComponents/buttons";

import { getMyShopPageRoute, CREATE_SHOP_STEPS } from "@constants/routes";

import style from "./purge-main.module.scss";

const CreateShopHeader = ({
  step,
  headerSteps = CREATE_SHOP_STEPS,
  onExit = null,
  cancelBtnText = "EXIT",
  title = "Create Your Shop",
  stepsRequired = true,
  renderCancelBtn,
}) => {
  const { asPath, push } = useRouter();

  const stepKey = (() => {
    if (!stepsRequired) return;
    return step || asPath.split("/")[3].split("?")[0].split("-")[0];
  })();

  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const totalSteps = Object.keys(headerSteps).length || 1;

  const handleClick = (e) => {
    e.preventDefault();
    return onExit?.(e) || push(getMyShopPageRoute());
  };

  const activeStepNo = headerSteps[stepKey]?.stepNo || 0;

  return (
    <div className={`${style.orderHeader}`}>
      <div className={`${style.pageContainer} ${style.createShopPageContainer}`}>
        <div
          className={`${style.headerContainer} ${
            isMobileDevice ? style["mobileHeaderContainer"] : ""
          }`}
        >
          <h3 className={`${style.title} ${style.title}`}>
            {title} {isMobileDevice && stepsRequired && `(${activeStepNo + 1}/${totalSteps})`}
          </h3>
          {!isMobileDevice && stepsRequired && (
            <div className={`create-shop-steps ${style.headerStepsOl}`}>
              {Object.values(headerSteps).map(({ key, name }, idx) => {
                const isActive = key === stepKey;
                const isCompleted = activeStepNo > idx;

                return (
                  <span
                    key={`create-shop-step-${key}`}
                    className={`${style.headerStepsLi} ${isActive ? style.active : ""} ${
                      isCompleted ? style.complete : ""
                    }`}
                  >
                    <span className={style.completeMark}></span>
                    <span className={style.value}>{name}</span>
                  </span>
                );
              })}
            </div>
          )}
          {renderCancelBtn ? (
            renderCancelBtn({
              children: isMobileDevice ? "" : cancelBtnText,
              className: style.saveLink,
            })
          ) : (
            <ExternalLinkButton btnStyle="link" className={style.saveLink} onClick={handleClick}>
              {isMobileDevice ? "" : cancelBtnText}
            </ExternalLinkButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateShopHeader;
